
















import { log } from '@/log'
import {
  AvailableMemberPlanRepository,
  DefaultAvailableMemberPlanRepository
} from '@/models/api/paid-member-price/member-plan/available-member-plan-repository'
import {
  AvailableMembershipPlan
} from '@/models/api/paid-member-price/member-plan/available-membership-plan'
import { AvailablePaidMemberPlanService } from '@/services/api/paid-member-plan'
import ErrorState from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/Error.vue'
import NotEverSubscribed from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/NotEverSubscribed.vue'
import Subscribed from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/Subscribed.vue'
import Unsubscribed from '@spa/components/pages/paid-membership/unsubscribe/confirm/state/Unsubscribed.vue'
import LoadingMixin from '@spa/mixins/loading'
import Vue, { VueConstructor } from 'vue'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

interface State {
  NotEverSubscribed: VueConstructor
  Subscribed: VueConstructor
  Unsubscribed: VueConstructor
  Loading: VueConstructor
  Error: VueConstructor
}
const stateComponents: State = {
  NotEverSubscribed,
  Subscribed,
  Unsubscribed,
  Loading: Vue.extend({
    name: 'Loading',
    template: '<div class="loading"></div>',
  }),
  Error: ErrorState,
}

@Component({
  components: {
    ...stateComponents,
  },
})
export default class Confirm extends Mixins<LoadingMixin>(LoadingMixin) {
  @Prop({ required: true })
  readonly planId: string

  @Prop({ required: true })
  readonly subscriptionId: string

  @Prop({ default: () => new DefaultAvailableMemberPlanRepository(new AvailablePaidMemberPlanService()) })
  readonly paidMembershipPlanRepository: AvailableMemberPlanRepository

  plan: AvailableMembershipPlan | null = null
  state: keyof State = 'Loading'

  loading: boolean = false

  async created() {
    this.loading = true

    this.paidMembershipPlanRepository.findBy(this.planId, this.subscriptionId).then((plan) => {
      this.plan = plan

      if (plan.notEverSubscribed()) {
        this.state = 'NotEverSubscribed'

        return
      }
      if (plan.unsubscribed()) {
        this.state = 'Unsubscribed'

        return
      }
      if (plan.subscribed()) {
        this.state = 'Subscribed'

        return
      }

      throw new Error(`unexpected state ${this.plan.externalId}`)
    }).catch((error) => {
      log.error(error)

      this.state = 'Error'
    }).finally(() => {
      this.loading = false
    })
  }
  get isLoading(): boolean {
    return this.loading
  }
}
